import { ReactNode } from 'react';

type IProps = {
  title: ReactNode;
};

export const CustomComponentTitle = ({ title }: IProps) => {
  return (
    <div className={'text-center text-3xl font-semibold lg:text-4xl'}>
      {title}
    </div>
  );
};
